import React from "react";
import GridLine, {BackgroundColor} from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../../components/fonts/font-props";

const PlanTotalPricingGridLine: React.FC<{ price: number | string }> = ({price}) => {
    return <GridLine
        withBorder={false}
        withoutSidePadding={true}
        backgroudColor={BackgroundColor.LIGHT}
        settings={
            {
                columns: [{width: 5}, {width: 2.5}, {width: 4}]
            }
        }
        columns={[
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    Total
                </FontBody2>
            </div>,
            <div/>,
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    ${price}
                </FontBody2>
                <FontBody2 color={FONT_COLOR.NEUTRAL3} variant={FONT_VARIANT.DEFAULT}>
                    &nbsp;/&nbsp;monthly
                </FontBody2>
            </div>,
        ]}
    />
}

export default PlanTotalPricingGridLine;